import { generatePalette, hexToRGBA, getContrast } from "../Color";
import { canIExecuteClientCode } from "../canI";

const generateTypographyStyles = (typography) => {
  let style = "";
  if (typography.css && typeof typography.css === "string") {
    style += typography.css;
  }
  if (typography.fonts && typeof typography.fonts === "object") {
    Object.keys(typography.fonts).map((fontName) => {
      if (typeof typography.fonts[fontName] === "object") {
        if (typography.fonts[fontName].preset)
          style += `@import url('${typography.fonts[fontName].preset}');`;
        else if (Array.isArray(typography.fonts[fontName].src)) {
          style += `@font-face {
            font-family: '${
              typography.fonts[fontName].alias
                ? typography.fonts[fontName].alias
                : fontName
            }';
            ${
              typography.fonts[fontName].fontStyle
                ? `font-style:${typography.fonts[fontName].fontStyle};`
                : ""
            }
            ${
              typography.fonts[fontName].fontWeight
                ? `font-weight:${typography.fonts[fontName].fontWeight};`
                : ""
            }
            ${
              typography.fonts[fontName].fontDisplay
                ? `font-display:${typography.fonts[fontName].fontDisplay};`
                : ""
            }
            src:`;

          typography.fonts[fontName].local &&
            typography.fonts[fontName].local.forEach((local) => {
              style += `local('${local}'),`;
            });
          typography.fonts[fontName].src.forEach((fontSrc, index) => {
            style += `url('${fontSrc.url}') format('${fontSrc.format}')${
              index < typography.fonts[fontName].src.length - 1 ? "," : ""
            }`;
          });
          style += "}";
        }
        style += `.fr-font-name-${fontName
          .toLocaleLowerCase()
          .replace(/ /g, "-")}{font-family: '${
          typography.fonts[fontName].alias
            ? typography.fonts[fontName].alias
            : fontName
        }', 'sans-serif'}`;
      }
      return fontName;
    });
  }
  return style;
};

const generateStylesPalette = (palette, item, i) => {
  let hoverBgColor = item.color;
  let gradientTo = item.color;
  let gradientButtonToHover = item.color;
  let gradientButtonFromActive = item.color;
  let gradientButtonToActive = item.color;
  let gradientButtonTextActive = item.textColor;
  let hoverColor = item.textColor;
  let activeBgColor = item.color;
  let activeColor = item.textColor;

  if (palette[i + 2]) gradientTo = palette[i + 2].color;
  else if (palette[i - 2]) gradientTo = palette[i - 2].color;

  if (palette[i + 1]) gradientButtonToHover = palette[i + 1].color;
  else if (palette[i - 1]) gradientButtonToHover = palette[i - 1].color;

  if (palette[i + 2]) gradientButtonFromActive = palette[i + 2].color;
  else if (palette[i - 2]) gradientButtonFromActive = palette[i - 2].color;

  if (palette[i + 4]) gradientButtonToActive = palette[i + 4].color;
  else if (palette[i - 4]) gradientButtonToActive = palette[i - 4].color;

  if (palette[i + 4]) gradientButtonTextActive = palette[i + 4].textColor;
  else if (palette[i - 4]) gradientButtonTextActive = palette[i - 4].textColor;

  if (palette[i + 2]) hoverBgColor = palette[i + 2].color;
  else if (palette[i - 2]) hoverBgColor = palette[i - 2].color;

  if (palette[i + 2]) hoverColor = palette[i + 2].textColor;
  else if (palette[i - 2]) hoverColor = palette[i - 2].textColor;

  if (palette[i + 3]) activeBgColor = palette[i + 3].color;
  else if (palette[i - 3]) activeBgColor = palette[i - 3].color;

  if (palette[i + 3]) activeColor = palette[i + 3].textColor;
  else if (palette[i - 3]) activeColor = palette[i - 3].textColor;
  const styles = `
  button.fr-btn-${item.name}{
    background-color:${item.color};
    border-color:${item.color};
    color:${item.textColor} !important;
  }
  button.fr-btn-${item.name}:not(:disabled):not(.fr-disabled):active,
  button.fr-btn-${item.name}:not(:disabled):not(.fr-disabled):focus,
  button.fr-btn-${item.name}:not(:disabled):not(.fr-disabled):hover{
    background-color:${hoverBgColor};
    border-color:${hoverBgColor};
    color:${hoverColor}
  }
  button.fr-btn-${item.name}:not(:disabled):not(.fr-disabled):active,
  button.fr-btn-${item.name}:not(:disabled):not(.fr-disabled).fr-active,
  button.fr-btn-outline-${item.name}:not(:disabled):not(.fr-disabled):active,
  button.fr-btn-outline-${item.name}:not(:disabled):not(.fr-disabled).fr-active,
  button.fr-show > .fr-btn-outline-${item.name}.fr-dropdown-toggle{
    color: ${activeColor};
    background-color: ${activeBgColor};
    border-color: ${activeBgColor};
  }
  .fr-border-${item.name}{border-color: ${item.color} !important;}
  .fr-bg-${item.name}{background-color: ${item.color} !important;}
  .gradient.fr-bg-${item.name},fr-btn-outline-${item.name}:hover,
  button.gradient.fr-btn-${item.name}:not(:disabled):not(.fr-disabled){
    background-image: linear-gradient(to bottom,${item.color},${gradientTo});
  }
  button.gradient.fr-btn-${item.name}:not(:disabled):not(.fr-disabled):focus,
  button.gradient.fr-btn-${item.name}:not(:disabled):not(.fr-disabled):hover,
  button.gradient.fr-btn-outline-${
    item.name
  }:not(:disabled):not(.fr-disabled):focus,
  button.gradient.fr-btn-outline-${
    item.name
  }:not(:disabled):not(.fr-disabled):hover{
    background-image: linear-gradient(to bottom,${
      item.color
    },${gradientButtonToHover});
    color: ${item.textColor};
  }
  button.gradient.fr-btn-${item.name}:not(:disabled):not(.fr-disabled):active,
  button.gradient.fr-btn-outline-${
    item.name
  }:not(:disabled):not(.fr-disabled):active{
    background-image: linear-gradient(to bottom,${gradientButtonFromActive},${gradientButtonToActive});
    color: ${gradientButtonTextActive};
  }
  .fr-text-${item.name}{color: ${item.color} !important;}
  .fr-btn-outline-${item.name}{
    color: ${item.color};
    border-color: ${item.color};
  }
  .fr-btn-outline-${item.name}:hover{
    color: ${item.textColor};
    background-color: ${item.color};
    border-color: ${item.color};
  }
  .fr-btn-outline-${item.name}.fr-disabled,
  .fr-btn-outline-${item.name}:disabled{
    color: ${item.color} !important;
    background-color: transparent !important;
    border-color: ${item.color} !important;
  }
  .fr-btn-outline-${item.name}:not(:disabled):not(.fr-disabled):active:focus,
  .fr-btn-${item.name}:not(:disabled):not(.fr-disabled):active:focus,
  .fr-btn-outline-${item.name}:not(:disabled):not(.fr-disabled).fr-active:focus,
  .fr-show > .fr-btn-outline-${item.name}.fr-dropdown-toggle:focus{
    box-shadow: 0 0 0 0.2rem ${hexToRGBA(item.color)};
  }
  .fr-btn-${item.name}:focus, .fr-btn-outline-${item.name}:focus{
    box-shadow: 0 0 0 0.2rem ${hexToRGBA(item.color)};
  }
  .fr-component-hover-${
    item.name
  }:hover:not(.fr-row):not([class^=fr-col]):not(button)>*{
    color:${item.textColor} !important;
  }
  .fr-component-hover-${item.name}:hover:not(button){
    background-color:${item.color} !important;
    border-color:${hoverBgColor} !important;
  }
  .fr-icon.fr-i-${item.name} path{
    fill: ${item.color};
  }
  .fr-btn-${item.name} .fr-icon path{
    fill: ${item.textColor};
  }
`;
  return styles;
};

const initTheme = (theme) => {
  const generatedStyles = [];
  const themeToken = {
    palette: {},
    designTokens: theme.designTokens || {}
  };

  let outputFields = [];
  if (theme.config && theme.config.outputFields) {
    outputFields = theme.config.outputFields;
  }
  if (outputFields.includes("colors")) themeToken.colors = theme.colors;
  if (outputFields.includes("typography"))
    themeToken.typography = theme.typography;
  if (theme) {
    if (theme.typography) {
      generatedStyles.push(generateTypographyStyles(theme.typography));
    }
    if (theme.colors) {
      generatedStyles.push([
        `button.fr-btn:disabled{
          background-color:${
            theme.components &&
            theme.components.button &&
            theme.components.button.disabled &&
            theme.components.button.disabled.bgColor
              ? theme.components.button.disabled.bgColor
              : "#d4d4d4"
          };
          border-color:${
            theme.components &&
            theme.components.button &&
            theme.components.button.disabled &&
            theme.components.button.disabled.bgColor
              ? theme.components.button.disabled.bgColor
              : "#d4d4d4"
          };
          color:${
            theme.components &&
            theme.components.button &&
            theme.components.button.disabled &&
            theme.components.button.disabled.bgColor
              ? theme.components.button.disabled.bgColor
              : "#afafaf"
          }
        }
    `
      ]);
      const themeColorsKeys = Object.keys(theme.colors);
      for (let index = 0; index < themeColorsKeys.length; index += 1) {
        const colorName = themeColorsKeys[index];
        const colorValue = theme.colors[themeColorsKeys[index]];
        if (colorValue !== "none") {
          // Adding base color to palette
          themeToken.palette[`${colorName}`] = colorValue;
          const palette = generatePalette(colorValue, colorName);
          if (theme.config && theme.config.generatePalette) {
            palette.forEach((item, i) => {
              // Adding color variations to the palette
              themeToken.palette[`${item.name}`] = item.color;
              // Avoiding executing unnecessary code that is not needed in the SSR
              if (canIExecuteClientCode()) {
                const styles = generateStylesPalette(palette, item, i);
                generatedStyles.push(styles.replace(/\n. |\r/g, ""));
              }
            });
          } else {
            if (canIExecuteClientCode()) {
              const styles = generateStylesPalette(
                palette,
                {
                  color: colorValue,
                  name: colorName,
                  textColor: getContrast(colorValue)
                },
                11
              );
              generatedStyles.push(styles.replace(/\n. |\r/g, ""));
            }
          }
        }
      }
      if (theme.colors.primary) {
        const primaryHover = hexToRGBA(theme.colors.primary, 0.25);
        generatedStyles.push(
          `.fr-focus:focus, .fr-form-control:focus, .fr-focus\\:focus{box-shadow: 0 0 0 0.2rem ${primaryHover};outline: 0;}`
        );
      }
    }
    if (canIExecuteClientCode() && typeof document != "undefined") {
      const element = document.getElementById("frTheming");
      if (element) {
        element.innerHTML = generatedStyles.join(" ");
      } else {
        const themeStyleNode = `${generatedStyles.join(" ")}`;

        const body = document.body || document.getElementsByTagName("body")[0];
        const style = document.createElement("style");

        style.type = "text/css";
        style.id = "frTheming";
        if (style.styleSheet) {
          // This is required for IE8 and below.
          style.styleSheet.cssText = themeStyleNode;
        } else {
          style.appendChild(document.createTextNode(themeStyleNode));
        }
        body.appendChild(style);
      }
    }
  }
  return themeToken;
};

export { initTheme };
